export const StringLiterals = {
    emailEmpty:"Email is required",
    emailInvalid:"Email is invalid",
    nameEmpty:"Name is required",
    addressEmpty:"Address is required",
    invalidCustomerSupportNumber:"",
    priority_study_value:"Priority Studies must be positive integer ",
    typeEmpty:"Type is required",
    mobileEmpty:"Mobile is required",
    landlineEmpty:"Landline is required",
    hospitalNameEmpty:"Name is required field",
    hospitalMaxLength:"Name should be less than to 40 characters.",
    hospitalAddressEmpty:"Address is required field",
    refreshText:"Refresh",
    warningReport:"This report cannot be submitted as it is not locked by you.",

    saveReport:"Report saved successfully",
    submitReport:"Report submitted successfully",
    markSuspect:"Study marked as suspect"
}